<!--
  @description v2.0.3 流程管理-回收权限
  @author xiehan
  @date 2019/03/07
-->
<template>
  <div class="revokeRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="revokeRequest@submit"
      :requestTitle="$t('cloudApplication.revokeRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <!-- 回收人 -->
        <el-form ref="revokeForm" :model="revokeForm" :rules="revokeFormRule">
          <el-form-item :label="$t('cloudApplication.revokedPeople')" prop="revokedPeople">
            <el-popover placement="bottom" trigger="click" v-model="showRevokeList">
              <el-transfer filterable v-model="revokeForm.revokedPeople" :data="revokeList"></el-transfer>
              <el-button type="text"
                @click="getRevokeList"
                slot="reference"
                v-text="$t('cloudApplication.choose')"></el-button>
            </el-popover>
          </el-form-item>
        </el-form>
        <!-- 添加仓库 -->
        <div class="mt-base">
          <label class="el-form-item__label center__label" v-text="$t('envauthority.repertory')"></label>
          <el-button type="primary" 
            @click="openResourceDia"
            v-text="$t('envauthority.addResource')"></el-button>
        </div>
        <div class="mt-base resource-table__wrap" v-for="(resourceItem, index) in resourceList" :key="resourceItem.flagId + index">
          <div v-text="select_resource[resourceItem.flagId]" 
            v-show="resourceItem.data && resourceItem.data.length > 0"></div>
          <table class="mt-base" v-show="resourceItem.data && resourceItem.data.length > 0">
            <thead>
              <tr>
                <th class="t-border" 
                  v-for="(item, index) in resourceItem.parton" 
                  :key="index"
                  v-text="item"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in resourceItem.data" :key="item.id">
                <td class="t-border" 
                  v-for="(_item, index) in resourceItem.parton"
                  v-show="index !== 'operate'"
                  :key="index"
                  v-text="item[index]"
                  :title="item[index]"></td>
                <td class="t-border">
                  <span class="t-border-btn" v-text="$t('common.delete')" @click="deleteResource(item)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 添加机器 -->
        <div class="mt-base">
          <label class="el-form-item__label center__label" v-text="$t('envauthority.machine')"></label>
          <el-button type="primary" 
            @click="openHostDia"
            v-text="$t('envauthority.addHost')"></el-button>
        </div>
        <div class="mt-base" style="margin-left: 70px;">
          <table v-show="machinesList.length > 0">
              <thead>
                <tr>
                  <th class="t-border" v-text="'IP'"></th>
                  <th class="t-border" v-text="$t('envauthority.operate')"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in machinesList" :key="item.ip">
                  <td class="t-border" v-text="item.ip"></td>
                  <td class="t-border">
                    <span class="t-border-btn" v-text="$t('common.delete')" @click="deleteMachine(item)"></span>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
    <!-- 仓库弹窗 -->
    <el-dialog :closeOnClickModal="false" 
      :title="$t('envauthority.addResource')" 
      :visible.sync="resourceDiaVis" 
      width="800px">
      <el-form ref="searchResourceForm" :inline="true" input-width="auto">
        <el-form-item>
          <el-select v-model="flagId" filterable>
            <el-option v-for="(item, key) in select_resource" :label="item" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="searchResourceList" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="resourceTableData"
        :head="resourceTableHead"
        :currentChange="resourceCurrentChange"
        :sizeChange="resourceSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="resourceTableOperate" 
            :data="data" 
            :label="$t('envauthority.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <table class="resource-dia-table" v-show="tempResourceData.length > 0">
        <thead>
          <tr>
            <th class="t-border" 
              v-for="(item, index) in tempResourceHead" 
              v-text="item"
              :key="index"
              v-show="index !== 'operate'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tempResourceData" :key="item.id">
            <td class="t-border" 
              v-for="(_item, index) in tempResourceHead"
              :key="index"
              v-show="index !== 'operate'"
              v-text="item[index]"></td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <el-button @click="resourceDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="saveResource" v-text="$t('common.confirm')" type="primary"></el-button>
        <el-button @click="tempResourceData = []" v-text="$t('envauthority.clearAll')" type="primary"></el-button>
      </div>
    </el-dialog>
    <!-- 主机列表弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('envauthority.addHost')" 
      :visible.sync="hostDiaVis" 
      width="800px">
      <el-form ref="searchHostForm" :model="searchHostForm" :inline="true" input-width="auto">
        <el-form-item :label="$t('envauthority.department')">
          <g-select :list="select_group" v-model="searchHostForm.group" :default-all="true"></g-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchHostForm.ip" :placeholder="$t('envauthority.byIp')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="searchHostList(true)" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="addCurrent" 
            v-text="$t('envauthority.addCurrentPage')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="hostTableData"
        :head="hostTableHead"
        :currentChange="hostCurrentChange"
        :sizeChange="hostSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="hostTableOperate" 
            :data="data" 
            :label="$t('envauthority.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <div class="ip-dia-wrap" v-show="selectMachines.length > 0">
        <div class="each-ip" v-for="(item, index) in selectMachines" :key="item.ip + index">
          <i class="icon iconfont icon-amc_circle_close icon-delete" @click="selectMachines.splice(index, 1)"></i>
          <span v-text="item.ip"></span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="hostDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="saveMachine" v-text="$t('common.confirm')" type="primary"></el-button>
        <el-button @click="selectMachines = []" v-text="$t('envauthority.clearAll')" type="primary"></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import repertoryBiz from '@/logic/cmdb/repertoryBiz'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import envauthorityBiz from '@/logic/continuousDelivery/envauthorityBiz'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_operate: {},
        status: '1',
        disAgreeInfo: {},
        processTable: [],
        showRevokeList: false,
        resourceDiaVis: false,
        hostDiaVis: false,
        revokeList: [],
        revokeForm: {
          revokedPeople: []
        },
        revokeFormRule: {
          revokedPeople: [
            { required: true, message: this.$t('cloudApplication.revokedPeopleTips') }
          ]
        },
        flagId: '',
        select_resource: {},
        select_group: {},
        searchHostForm: {
          group: '',
          ip: ''
        },
        resourceTableHead: [],
        resourceTableData: [],
        resourceCurrentPage: 1,
        resourcePerPageCount: 10,
        hostTableData: {},
        hostTableHead: [],
        hostCurrentPage: 1,
        hostPerPageCount: 10,
        tempResourceHead: {},
        tempResourceData: [],
        resourceTableOperate: [{
          label: this.$t('envauthority.addTo'),
          callback: (row, index, data) => {
            let obj = {}
            this.resourceTableHead.map(item => {
              obj[item.key] = item.label
            })
            this.tempResourceHead = { ...obj, operate: this.$t('envauthority.operate') }
            if (this.tempResourceData.filter(item => item.id === row.id).length === 0) {
              this.tempResourceData.push({
                ...row,
                flagId: this.flagId
              })
            }
          }
        }],
        hostTableOperate: [{
          label: this.$t('envauthority.addTo'),
          callback: (row, index, data) => {
            if (this.selectMachines.filter(item => item.ip === row.ip1).length === 0) {
              this.selectMachines.push({
                ip: row.ip1
              })
            }
          }
        }],
        resourceList: [],
        selectMachines: [],
        currentIpList: [],
        machinesList: []
      }
    },
    components: {
      requestNote
    },
    methods: {
      init () {
        this.waitGroup()
        this.getResourceData()
        this.getDic()
      },
      getRevokeList () {
        this.showRevokeList = !this.showRevokeList
        this.revokeList = []
        envauthorityBiz.findEnvAuthority({
          currentPage: 1,
          perPageCount: 99999
        }).then((data) => {
          data.dataList.map(item => {
            this.revokeList.push({
              key: item.id,
              label: item.name
            })
          })
        })
      },
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      getRequestForm (val) {
        this.$refs['revokeForm'].validate((valid) => {
          if (valid) {
            let repository = []
            this.resourceList.map(resourceItem => {
              if (resourceItem.data.length !== 0) {
                let authList = []
                resourceItem.data.map(authItem => {
                  authList.push({
                    id: authItem.id
                  })
                })
                repository.push({
                  flagId: resourceItem.flagId,
                  authList: authList
                })
              };
            })
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              host: this.machinesList,
              repository: repository,
              revokeIds: this.revokeForm.revokedPeople,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitRevokeApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      openHostDia () {
        this.selectMachines = []
        this.machinesList.map(item => {
          this.selectMachines.push(item)
        })
        this.hostDiaVis = true
      },
      setResourceList (repository) {
        let resourceList = []
        repository.map(item => {
          let parton = {}
          item.properties.map(_item => {
            if (_item.display) {
              parton[_item['property']] = _item['name']
            }
          })
          resourceList.push({
            flagId: item.flagId,
            data: item.authList,
            parton: parton
          })
        })
        this.resourceList = resourceList
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.revokeForm.revokedPeople = data.info.revokeIds
          this.setDefaultTableInfo(data.info)
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      },
      setDefaultTableInfo (data) {
        let resourceList = []
        data.repository.map(item => {
          let parton = {}
          item.properties.map(_item => {
            if (_item.display) {
              parton[_item['property']] = _item['name']
            }
          })
          parton['operate'] = this.$t('common.handle')
          resourceList.push({
            flagId: item.flagId,
            data: item.authList,
            parton: parton
          })
        })
        this.resourceList = resourceList
        data.host.map((item) => {
          this.machinesList.push({
            ip: item.ip
          })
        })
      },
      openResourceDia () {
        this.tempResourceData = []
        this.resourceDiaVis = true
      },
      getResourceDic () {
        return resourceModelBiz.getResource().then((data) => {
          let obj = {}
          data.map((item) => {
            if (item.resourceType === '3') {
              obj[item.flagId] = item.resourceName
            }
          })
          this.select_resource = { ...obj }
          this.flagId = Object.keys(this.select_resource)[0]
        })
      },
      getResourceData () {
        return new Promise((resolve) => {
          this.getResourceDic().then(() => {
            this.setResourceData(resolve)
          })
        })
      },
      setResourceData (resolve) {
        this.setResourceParton({
          resourceType: '3',
          flagId: this.flagId
        }).then(() => {
          repertoryBiz.getInstance({
            resourceType: '3',
            flagId: this.flagId,
            currentPage: this.resourceCurrentPage,
            perPageCount: this.resourcePerPageCount
          }).then((data) => {
            this.resourceTableData = data
          })
          if (resolve) resolve()
        })
      },
      setResourceParton (propertyParam) {
        return resourceModelBiz.getProperty(propertyParam).then((data) => {
          this.resourceTableHead = []
          data.dataList.map((item) => {
            if (item.display && propertyParam.resourceType === '3') {
              this.resourceTableHead.push({ key: item.property, label: item.name })
            }
          })
        })
      },
      searchResourceList () {
        this.tempResourceData = []
        this.resourceCurrentPage = 1
        this.resourcePerPageCount = 10
        this.setResourceData()
      },
      resourceCurrentChange (val) {
        this.resourceCurrentPage = val
        this.setResourceData()
      },
      resourceSizeChange (val) {
        this.resourceCurrentPage = 1
        this.resourcePerPageCount = val
        this.setResourceData()
      },
      saveResource () {
        if (this.tempResourceData.length === 0) {
          this.resourceDiaVis = false
          return
        }
        if (this.resourceList.filter(item => item.flagId === this.flagId).length === 0) {
          this.resourceList.push({
            flagId: this.flagId,
            parton: this.tempResourceHead,
            data: this.tempResourceData
          })
        } else {
          let flagIndex = this.resourceList.findIndex(item => item.flagId === this.flagId)
          this.tempResourceData.map((item) => {
            if (this.resourceList[flagIndex].data.filter(_item => item.id === _item.id).length === 0) {
              this.resourceList[flagIndex].data.push(item)
            }
          })
        }
        this.resourceDiaVis = false
      },
      deleteResource (info) {
        let flagIndex = this.resourceList.findIndex(item => item.flagId === info.flagId)
        let deleteIndex = this.resourceList[flagIndex].data
          .findIndex(item => item.id === info.id)
        this.resourceList[flagIndex].data.splice(deleteIndex, 1)
        if (this.resourceList[flagIndex].data.length === 0) this.resourceList.splice(flagIndex, 1)
      },
      async waitGroup () {
        await Promise.all([
          this.dGetDictionaryByCode('hostStatus'),
          this.dGetGroup()
        ])
        this.select_group = { ...this.dDictionaryGroup }
        this.searchHostList()
      },
      searchHostList (fromClick = false) {
        if (fromClick) {
          this.hostCurrentPage = 1
          this.hostPerPageCount = 10
        }
        this.initTable()
        let searchObj = {
          currentPage: this.hostCurrentPage,
          perPageCount: this.hostPerPageCount
        }
        Object.keys(this.searchHostForm).map((item) => {
          if (this.searchHostForm[item]) {
            searchObj[item] = this.searchHostForm[item]
          }
        })
        cmdbBiz.hostList(searchObj).then((data) => {
          data.dataList.map(item => {
            if (item.group && item.group.length > 1) {
              item.group = item.group.join(',')
            }
          })
          this.currentIpList = []
          data.dataList.map(item => {
            this.currentIpList.push(item.ip1)
          })
          this.hostTableData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      hostCurrentChange (val) {
        this.hostCurrentPage = val
        this.searchHostList()
      },
      hostSizeChange (val) {
        this.hostCurrentPage = 1
        this.hostPerPageCount = val
        this.searchHostList()
      },
      initTable () {
        this.hostTableHead = [
          { key: 'department', label: this.$t('envauthority.hostTable.group') },
          { key: 'hostName', label: this.$t('envauthority.hostTable.hostName') },
          { key: 'ip1', label: this.$t('envauthority.hostTable.ip1') },
          { key: 'status',
            label: this.$t('envauthority.hostTable.status'),
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostStatus }
        ]
      },
      addCurrent () {
        this.currentIpList.map(item => {
          if (this.selectMachines.filter(_item => _item.ip === item).length === 0) {
            this.selectMachines.push({
              ip: item
            })
          }
        })
      },
      saveMachine () {
        this.machinesList = []
        this.selectMachines.map((item) => {
          if (this.machinesList.filter(_item => item.ip === _item.ip).length === 0) {
            this.machinesList.push(item)
          }
        })
        this.hostDiaVis = false
      },
      deleteMachine (info) {
        let index = this.machinesList.findIndex(item => item.ip === info.ip)
        this.machinesList.splice(index, 1)
      },
      resetRequest () {
        this.hostCurrentPage = 1
        this.hostPerPageCount = 10
        this.searchHostForm.group = ''
        this.searchHostForm.ip = ''
        this.revokeForm.revokedPeople = []
        this.resourceList = []
        this.machinesList = []
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'revokeRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.resetRequest()
          this.$nextTick(() => {
            this.$refs.requestNote.init()
            this.$refs.revokeForm.clearValidate()
          })
          this.init()
        } else if (to.name === 'revokeRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.resetRequest()
          this.init()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.init()
    }
  }
</script>

<style scoped>
  .center__label {
    display: inline-block;
    width: 70px;
    float: none;
  }
  .resource-table__wrap {
    overflow-x: scroll;
    margin-left: 70px;
  }
  .resource-dia-table {
    margin-top: 10px;
    overflow-x: auto;
    display: inline-block;
    width: 100%;
  }
  .ip-dia-wrap {
    border: 1px solid #ddd;
    width: 756px;
    margin: 8px auto;
  }
  .each-ip {
    width: 124px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .each-ip:hover {
    background: #eaeaea;
    border: 1px solid #ddd;
  }
  .each-ip:hover .icon-delete {
    display: block;
  }
  .icon-delete {
    display: none;
    color: #a0a0a0;
    font-size: 18px;
    position: absolute;
    bottom: 20px;
    right: -8px;
  }
  .icon-delete:hover {
    color: #3385ff;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .t-border {
    height: 30px;
    width: 110px;
    min-width: 84px;
    max-width: 150px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-border-btn {
    color: #0B8DE5;
    cursor: pointer;
  }
  .t-border-btn:hover {
    color: #3ca4ea;
  }
</style>